export default __webpack_public_path__ + "static/design-elements-light-6f0e9912fc7902dda825a63b729a61f4.svg";